import { gql, useQuery } from "@apollo/client";

const GET_DIVISIONS = gql`
  query getAccountDivisions {
    account {
      divisions {
        id
        name
      }
    }
  }
`;

export const useDivisions = () => {
  const {
    data: { account: { divisions } = {} } = {},
    loading,
    refetch
  } = useQuery(GET_DIVISIONS);

  return {
    divisions,
    loading,
    refetch
  };
};
